// src/DeveloperAd.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DeveloperAd.css';

function DeveloperAd() {
  const navigate = useNavigate();

  return (
    <div className="god-mode-wrapper">
      
      {/* Return Button */}
      <button onClick={() => navigate(-1)} className="back-link">
        ← Return to Portal
      </button>
      
      <div className="ad-glass-card">
        
        <div className="ad-title">
          Ready to <span className="gradient-text">Boost Your Business?</span>
        </div>
        
        <div className="ad-developer-name">
          System Architect <span>Gagandeep Singh Bhullar</span>
        </div>

        <div className="skills-container">
          <div className="skill-chip">Web Platforms</div>
          <div className="skill-chip">Mobile Apps</div>
          <div className="skill-chip">IoT Networks</div>
          <div className="skill-chip">Automation</div>
          <div className="skill-chip">AI Systems</div>
        </div>

        <a href="tel:+917087298636" className="contact-btn-god">
         +9170872 98636
        </a>
        
      </div>
    </div>
  );
}

export default DeveloperAd;